import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import Mainpage from './components/dashboard/Mainpage'
import Dashboard from './components/dashboard/Dashboard'
import IPFSDashboard from './components/dashboard/IPFSDashboard'
import ProjectDetails from './components/projects/ProjectDetails'
import Team from './components/layout/Team'
import UpgradeAccount from './components/layout/UpgradeAccount'
import PlansPricing from './components/layout/PlansPricing'
import HelpCenter from './components/layout/HelpCenter'
import Checkout from './components/payments/Checkout'
import CancelSubscription from './components/payments/CancelSubscription'

// import IPFSDetails from './components/projects/IPFSDetails'
import SignIn from './components/auth/SignIn'
import SignUp from './components/auth/SignUp'
import CreateProject from './components/projects/CreateProject'
import HasTemplate from './components/projects/HasTemplate'
import CreateTemplate from './components/projects/CreateTemplate'
import RegisterSign from './components/projects/RegisterSign'
import UserProfile from './components/projects/UserProfile'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIgloo, faBook, faMagic, faSearch, faCheck, faBookOpen, faPaperPlane, faFile, faDatabase, faDownload } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faIgloo, faBook, faMagic, faSearch, faCheck, faBookOpen, faPaperPlane, faFile, faDatabase, faDownload)

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <Switch>
            <Route exact path="/" component={Mainpage} />
            <Route path="/project/:id" component={ProjectDetails} />
            {/* <Route path="/signed/:id" component={IPFSDetails} /> */}
            <Route path='/dashboard' component={Dashboard} />
            <Route path='/signed' component={IPFSDashboard} />
            <Route path='/signin' component={SignIn} />
            <Route path='/signup' component={SignUp} />
            <Route path='/Create' component={CreateProject} />
            <Route path='/hastemplate' component={HasTemplate} />
            <Route path='/newtemplate' component={CreateTemplate} />
            <Route path='/team' component={Team} />
            <Route path='/plans' component={PlansPricing} />
            <Route path='/help' component={HelpCenter} />
            <Route path='/mysign' component={RegisterSign} />
            <Route path='/profile' component={UserProfile} />
            <Route path='/upgrade' component={UpgradeAccount} />
            <Route path='/payment' component={Checkout} />
            <Route path='/unsubscribe' component={CancelSubscription} />

          </Switch>
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
